module.exports = __webpack_public_path__ + "static/media/icn_life insurance_f.d04e8a88.svg";